"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modelCanRun = modelCanRun;
exports.carbonEmissions = carbonEmissions;
exports.modelCanRunVersion = exports.explanation = exports.modelVersion = exports.modelName = void 0;

var _md = _interopRequireDefault(require("tiny-hashes/md5"));

var _definitions = require("../../definitions");

var energyFootprints = {
  heating: {
    HEATING_SOURCE_COAL_BOILER: {
      kWh: {
        intensityKilograms: 0.63,
        source: "https://www.icax.co.uk/Decarbonising_Heating_2022.html"
      }
    },
    HEATING_SOURCE_OIL_BOILER: {
      kWh: {
        intensityKilograms: 0.43,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_GAS_BOILER: {
      kWh: {
        intensityKilograms: 0.295,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_GAS_MICRO_COMBINED_HEAT_AND_POWER: {
      kWh: {
        intensityKilograms: 0.26,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_GAS_ABSORPTION_HEAT_PUMP: {
      kWh: {
        intensityKilograms: 0.175,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_BIOSOURCED_GASES: {
      kWh: {
        intensityKilograms: 0.06,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_BIOMASS_BOILER: {
      kWh: {
        intensityKilograms: 0.1,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_GEOTHERMAL: {
      kWh: {
        intensityKilograms: 0.01,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_SOLAR_THERMAL: {
      kWh: {
        intensityKilograms: 0.0225,
        source: "http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf"
      }
    },
    HEATING_SOURCE_DISTRICT_HEATING: {
      kWh: {
        country: {
          AT: {
            intensityKilograms: 0.138613768592457,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          BE: {
            intensityKilograms: 0.153246230482934,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          BG: {
            intensityKilograms: 0.242628007169097,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          CY: {
            intensityKilograms: -0.00969682540749218,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          CZ: {
            intensityKilograms: 0.287764611249576,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          DE: {
            intensityKilograms: 0.188820002160917,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          DK: {
            intensityKilograms: 0.203981361123157,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          EE: {
            intensityKilograms: 0.163115712753168,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          ES: {
            intensityKilograms: 0,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          FI: {
            intensityKilograms: 0.185356469136768,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          FR: {
            intensityKilograms: 0.0827175916129129,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          UK: {
            intensityKilograms: 0.138031379296288,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          GR: {
            intensityKilograms: 0.315308456821223,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          HR: {
            intensityKilograms: 0.218491125208843,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          HU: {
            intensityKilograms: 0.181767842244441,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          IE: {
            intensityKilograms: 0,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          IT: {
            intensityKilograms: 0.200398663230602,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          LT: {
            intensityKilograms: 0.0966513330178206,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          LU: {
            intensityKilograms: 0.126744277506435,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          LV: {
            intensityKilograms: 0.104791562263033,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          MT: {
            intensityKilograms: 0.162345134012572,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          NL: {
            intensityKilograms: 0.157277165673387,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          PL: {
            intensityKilograms: 0.345769096000686,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          PT: {
            intensityKilograms: 0.272338841231362,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          RO: {
            intensityKilograms: 0.220377645786264,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          SE: {
            intensityKilograms: 0.0968585307202192,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          SI: {
            intensityKilograms: 0.269687224992362,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          },
          SK: {
            intensityKilograms: 0.375480331140096,
            source: "Lukas Kranzl, Michael Hartner, Andreas M\xFCller, Gustav Resch, Sara Fritz, (TU Wien), Tobias Fleiter, Andrea Herbst, Matthias Rehfeldt, Pia Manz (Fraunhofer ISI), Alyona Zubaryeva (EURAC). Reviewed by Jakob Rager (CREM). Hotmaps Project, D5.2 WP5 Report \u2013 Heating & Cooling outlook until 2050, EU 28, 2018 www.hotmaps-project.eu"
          }
        }
      }
    }
  }
}; // ** modelName must not be changed. If changed then old activities will not be re-calculated **

var modelName = 'energy';
exports.modelName = modelName;
var ymlChecksum = (0, _md["default"])(JSON.stringify(energyFootprints));
var modelVersion = "1_".concat(ymlChecksum); // This model relies on footprints.yaml

exports.modelVersion = modelVersion;
var explanation = {
  text: 'Calculations take into account use of electricity and heating, based on fuel source',
  links: [{
    label: 'ICAX (2019)',
    href: 'https://www.icax.co.uk/Decarbonising_Heating_2022.html'
  }, {
    label: 'The Parliamentary Office of Science and Technology (2016)',
    href: 'http://researchbriefings.files.parliament.uk/documents/POST-PN-0523/POST-PN-0523.pdf'
  }, {
    label: 'Hotmaps Project (2018)',
    href: 'https://www.hotmaps-project.eu'
  }]
};
exports.explanation = explanation;
var modelCanRunVersion = 1;
exports.modelCanRunVersion = modelCanRunVersion;

function modelCanRun(activity) {
  var heatingSource = activity.heatingSource,
      activityType = activity.activityType,
      countryCodeISO2 = activity.countryCodeISO2; // Leave the electric activities up to the electricity model

  var isElectricActivity = _definitions.ELECTRICITY_ACTIVITIES.includes(activityType);

  if (!heatingSource || isElectricActivity) {
    return false;
  }

  if (heatingSource === _definitions.HEATING_SOURCE_DISTRICT_HEATING && !countryCodeISO2) {
    return false;
  }

  return true;
}

function correctWithParticipants(footprint, participants) {
  return footprint / (participants || 1);
}
/*
Carbon emissions of an activity (in kgCO2eq)
*/


function carbonEmissionsWithoutParticipants(activity) {
  var countryCodeISO2 = activity.countryCodeISO2,
      heatingSource = activity.heatingSource,
      energyWattHours = activity.energyWattHours;

  if (!heatingSource) {
    throw new Error('Missing heatingSource');
  }

  var energyFootprint = (energyFootprints.heating[heatingSource] || {}).kWh;

  if (!energyFootprint) {
    throw new Error("Unable to find a footprint for heatingSource ".concat(heatingSource));
  }

  if (energyWattHours == null) {
    throw new Error('Missing energyWattHours');
  } // Check if we can use the country-specific estimate


  if (energyFootprint.country && countryCodeISO2 && energyFootprint.country[countryCodeISO2] && energyFootprint.country[countryCodeISO2].intensityKilograms) {
    // Get country-specific values
    var countryCarbonIntensity = energyFootprint.country[countryCodeISO2].intensityKilograms;
    return energyWattHours / 1000.0 * countryCarbonIntensity;
  } // Use non-country specific estimator


  if (!energyFootprint.intensityKilograms) {
    throw new Error("Unable to find a non-country-specific carbon intensity for heatingSource ".concat(heatingSource));
  }

  return energyWattHours / 1000.0 * energyFootprint.intensityKilograms;
}

function carbonEmissions(activity) {
  return correctWithParticipants(carbonEmissionsWithoutParticipants(activity), activity.participants);
}